import {
  AttachmentFileInterface,
  EmailBaseInterface,
  EmailUpdateInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'

type AttachmentUpdateData = { id: number } | { file: number }

const getAttachmentsUpdateData = (
  attachmentsTempState: (AttachmentFileInterface | UnsavedAttachmentFileInterface)[],
): AttachmentUpdateData[] => {
  return attachmentsTempState.map(item => {
    if ('id' in item) {
      return { id: item.id }
    }
    return { file: item.file.id }
  })
}

export const getMailingUpdateData = (
  data: EmailBaseInterface,
  attachmentsTempState: (AttachmentFileInterface | UnsavedAttachmentFileInterface)[],
): EmailUpdateInterface => {
  return {
    subject: data.subject,
    fromEmail: data.fromEmail,
    fromName: data.fromName,
    previewText: data.previewText,
    body: data.body,
    useNewEditor: data.useNewEditor,
    attachments: getAttachmentsUpdateData(attachmentsTempState),
  }
}
